import { createReducer, on } from '@ngrx/store';
import { Tag, TagsListMeta } from '../models/tag.model';
import * as TagsActions from './tags.actions';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export interface TagsQueryState {
  search?: string;
  filters?: ApiTableFilter[];
  filterLink?: string;
  sort?: string;
  sortDirection?: string;
}

export interface TagsState {
  tags: Tag[];
  meta: TagsListMeta | null;
  isLoading: boolean;
  isSubmitting: boolean;
  isDeleting: boolean;
  error: string | null;
  lastQuery: TagsQueryState;
}

const initialState: TagsState = {
  tags: [],
  meta: null,
  isLoading: false,
  isSubmitting: false,
  isDeleting: false,
  error: null,
  lastQuery: {},
};

export const tagsReducer = createReducer(
  initialState,

  on(TagsActions.loadTags, (state, action) => ({
    ...state,
    isLoading: true,
    error: null,
    lastQuery: {
      search: action.search,
      filters: action.filters,
      filterLink: action.filterLink,
      sort: action.sort,
      sortDirection: action.sortDirection,
    },
  })),
  on(TagsActions.loadTagsSuccess, (state, { tags, meta }) => ({
    ...state,
    tags,
    meta,
    isLoading: false,
  })),
  on(TagsActions.loadTagsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(TagsActions.submitTag, (state) => ({
    ...state,
    isSubmitting: true,
    error: null,
  })),
  on(TagsActions.submitTagSuccess, (state) => ({
    ...state,
    isSubmitting: false,
  })),
  on(TagsActions.submitTagFailure, (state, { error }) => ({
    ...state,
    isSubmitting: false,
    error,
  })),

  on(TagsActions.deleteTag, (state) => ({
    ...state,
    isDeleting: true,
    error: null,
  })),
  on(TagsActions.deleteTagSuccess, (state) => ({
    ...state,
    isDeleting: false,
  })),
  on(TagsActions.deleteTagFailure, (state, { error }) => ({
    ...state,
    isDeleting: false,
    error,
  })),

  on(TagsActions.resetTagsState, () => initialState),
);
